// External libraries
import * as React from "react";

// UITK
import { UitkInput, UitkInputProps } from "uitk-react-input";

export const TypeaheadFallbackInput: React.FC<UitkInputProps> = (props) => {
  return (
    <UitkInput
      autoCapitalize="off"
      autoComplete="off"
      autoCorrect="off"
      type="text"
      spellCheck={false}
      icon="place"
      {...props}
    />
  );
};

/**
 * Custom Hook to lazy loading the UITK Typeahead package
 */
export const useLazyTypeahead = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [typeaheadModule, setTypeaheadModule] = React.useState<typeof import("uitk-react-typeahead") | null>(null);

  const loadTypeahead = React.useCallback(async () => {
    setIsLoading(true);
    const module = await import("uitk-react-typeahead");
    setTypeaheadModule(module);
    setIsLoading(false);
  }, []);

  React.useEffect(() => {
    loadTypeahead();
  }, [loadTypeahead]);

  return {
    typeaheadModule,
    isLoading,
  };
};
